<template>
  <div class="video-custom">
    <h2 class="text-2xl font-bold text-center mb-6">
      {{ $t('video_section_main_title') }}
    </h2>

    <div class="video-grid">
      <div
        v-for="videoId in videoIds"
        :key="videoId"
        class="video-wrapper"
      >
        <iframe
          :src="`https://www.youtube.com/embed/${videoId}`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>

    <div class="view-all-btn-container">
      <a
        href="#"
        class="default-btn"
        @click.prevent="openYouTubeChannel"
      >
        {{ $t('button_view_all') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoGrid',
  data() {
    return {
      videoIds: [
        'VHaDjKGM8UE',
        'zdahN70xtDw',
        'fRVfhnm0Dvo',
        'Y9QLolmAoZY',
      ]
    }
  },
  methods: {
    openYouTubeChannel() {
      window.open('https://www.youtube.com/@SMILEMAKEOVER4U', '_blank', 'noopener')
    }
  }
}
</script>

<style scoped>
.video-custom {
  padding: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.video-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

/* Video wrapper with proper aspect ratio */
.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  overflow: hidden;
  border-radius: 0.5rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  background-color: #000;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0.5rem;
  display: block;
}

/* View All button */
.view-all-btn-container {
  margin-top: 2rem;
  text-align: center;
}
</style>
